window.silesia = window.silesia || {};
window.silesia.layout = window.silesia.layout || {};

window.silesia.layout.commentForm = function() {
    return {
        form:null,
        error: false,
        statusOK: false,
        statusValidating:false,
        statusPending:false,
        statusReseting:false,
        parent: 0,

        load:function() {
            var self = this;
            this.form = (this.$root.tagName.toUpperCase()=='FORM') ? this.$root : this.$root.querySelector('FORM');
            this.form.noValidate = true;
            this.form.onsubmit = (e) => self.submit(e);
        },

        resetStatus:function(msec=1500) {
            var self = this;
            
            if(!self.statusReseting) {
                self.statusReseting = true;
                setTimeout(function(){
                    self.error = false;
                    self.statusOK = false;
                    self.statusValidating = false;
                    self.statusPending = false;
                    self.statusReseting = false;
                }, msec);
            }            
        },

        submit:function(e) {
            e.preventDefault();
            var self = this;

            var postData = {};
            (new FormData(self.form)).forEach((v,k) => {postData[k]=v});

            self.statusValidating = true;
        
            if(!self.form.reportValidity()) {
                self.statusOK = false;
                self.error = 'Nie wypełniono wszystkich pól';
                self.resetStatus(5500);
                return false;
            }

            self.statusValidating = false;
            self.statusPending = true;

            fetch('?', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(postData)
            })
                .then(response => {
                    self.statusPending = false;
                    if(self.form['g-recaptcha-response'] && !self.form['g-recaptcha-response'].value) {
                        throw new Error('Sprawdź kod Captcha!');
                    } else if(!response.ok){
                        throw new Error('Błąd sieci!');
                    }
                    return response.json();
                })
                .then(data => {
                    self.statusPending = false;
                    if(data.status&&data.status=='ok'){
                        self.statusOK = true;
                        self.error = false;
                        self.form.reset();
                    } else {
                        self.statusOK = false;
                        self.error = data.error || data.message || 'Nieznany błąd';
                    }
                    self.resetStatus(5500);
                })
                .catch(error => {
                    self.statusPending = false;
                    self.statusOK = false;
                    self.error = error;
                    self.resetStatus(5500);
                }); 

            return false;
        }        
    };
}




if(document.querySelector('*[x-data-lazy*="window.silesia.layout.commentForm"]')) {
    for(var el of document.querySelectorAll('*[x-data-lazy*="window.silesia.layout.commentForm"]')) {
        el.setAttribute('x-init', 'load');
        el.setAttribute('x-data', el.getAttribute('x-data-lazy'));
        el.removeAttribute('x-data-lazy');
    };
}